import { render, staticRenderFns } from "./viewAppointment.vue?vue&type=template&id=723f467c"
import script from "./viewAppointment.vue?vue&type=script&lang=js"
export * from "./viewAppointment.vue?vue&type=script&lang=js"
import style0 from "./viewAppointment.vue?vue&type=style&index=0&id=723f467c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports